import { ArrowLeft, CheckSquare, Square } from "lucide-react"
import { Button } from "components/ui/button"
import { formatOperatorName } from "@/utils/format-operator-name"
import type { ReviewHeaderProps } from "../../types/components"

export const ReviewHeader = ({
  email,
  selectedCount,
  isAllSelected,
  onBack,
  onToggleAll,
  isLoading
}: ReviewHeaderProps) => (
  <div className="flex items-center gap-3 pb-3 border-b flex-shrink-0">
    <Button variant="outline" size="sm" onClick={onBack} disabled={isLoading}>
      <ArrowLeft className="w-4 h-4 mr-1" />
      Voltar
    </Button>

    <div className="flex-1 min-w-0">
      <h3 className="text-base font-semibold truncate">
        E-mail #{email.email_id} • {formatOperatorName(email.requested_by_email)}
      </h3>
      <p className="text-xs text-gray-600">
        {email.totalItems} item(s) • {selectedCount} selecionado(s)
      </p>
    </div>

    <div className="flex gap-2">
      <Button variant="outline" size="sm" onClick={onToggleAll} disabled={isLoading}>
        {isAllSelected ? (
          <CheckSquare className="w-4 h-4 mr-1" />
        ) : (
          <Square className="w-4 h-4 mr-1" />
        )}
        {isAllSelected ? "Desmarcar" : "Selecionar"} Disponíveis
      </Button>
    </div>
  </div>
)
